export const CLASS_NAME_PREFIX_ANIM = 'cc.animation.';

export const createEvalSymbol = Symbol('CreateEval');
